import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    Authorization: localStorage.getItem('Authorization') ? localStorage.getItem('Authorization') : '',
    CurrentUser: localStorage.getItem('CurrentUser') ? localStorage.getItem('CurrentUser') : '匿名用户',
    RegionInfo: null,
    CurrentCustomerDetails: null,
  },

  mutations: {
    update (state, [key, value]) {
      state[key] = value
      localStorage.setItem(key, value)
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js